import * as React from "react";
import { DataSourceBrowser } from '../data-source-picker/datasource-editor/model-action-browser';
import { IContextProvider } from "../../../uxp";
import { IBaseProperty, IUIPropertyDefinition } from "../common";
import { dataSourceLabel, findDataSource, IDataSource, registerDataSource, TargetDataStructure } from "../data-source-picker/datasource";

interface IModelProperty extends IBaseProperty {
    model: string;
    action: string;
}

export function ModelProperty(title: string, source: string, sources: IDataSource[], context: IContextProvider, structure?: TargetDataStructure): IUIPropertyDefinition<string> {
    return {
        defaults: source,
        render: (props) => {
            let ds = findDataSource(source, sources);
            let name = ds ? dataSourceLabel(ds) : 'Unknown';
            let [isSelecting, setIsSelecting] = React.useState(false);

            function showBrowser() {
                setIsSelecting(true);
            }
            return <div className='wd-prop-item'>
                <div className='wd-prop-item-title'>{title}</div>
                <div className='wd-prop-item-editor' onClick={showBrowser}>
                    <label>Model</label>
                    <div className='wd-prop-item-editor-text'>
                        {name}
                    </div>
                </div>
                <div className='wd-prop-item-editor'>

                </div>
                {isSelecting && <DataSourceBrowser
                    contextData={props.contextData}
                    selectedSource={ds}
                    existingSources={sources}
                    onSelected={(source) => {
                        let existing = findDataSource(source.id, sources);
                        if (!existing) {
                            source = registerDataSource(source);
                        }


                        if (!existing) {
                            let newSources = (sources || []).slice();
                            newSources.push(source);
                            props.onChangeAny('datasources', newSources)
                        }
                        props.onChange(source.id);
                        setIsSelecting(false);
                    }}
                    onClose={() => setIsSelecting(false)}
                    context={context}
                    onRemove={id => {
                        const _sources = [...sources].filter(s => s.id != id)
                        props.onChangeAny('datasources', _sources)
                    }}
                />}
            </div>

                ;
        }
    };
}